import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import { pCore, rCore } from '../../../../api/models/.catalog';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';

export default ApiBaseReducer<pCore, IInputDataStateModel<pCore, rCore>, rCore>(
  ActionSubTypes.API_OTURUMKAPAT,
  DefaultInputDataStateModel<pCore, rCore>()
);
